<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,

  props: {
    chartData: {
      type: Object,
      default: null,
    },
    chartOptions: {
      type: Object,
      default: () => ({
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              fontColor: '#52565F',
              fontSize: 12,
            },
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: '#F3F3F3',
              lineWidth: 2,
              zeroLineColor: '#F3F3F3',
              zeroLineWidth: 2,
            },
            ticks: {
              fontColor: '#52565F',
              fontSize: 12,
            },
          }],
        },
      }),
    },
  },

  watch: {
    chartData(data) {
      // vue-chartjs exposes the Chart.js instance under this name.
      // eslint-disable-next-line no-underscore-dangle
      const chart = this.$data._chart
      if (chart) {
        chart.data = data
        chart.update()
      }
    },
  },

  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  },
}
</script>
